import * as jose from 'jose';

const SAML_NONCE_STORAGE_KEY = 'gitbook:saml:nonce';

/**
 * Bind a SAML login to this tab before leaving for the identity provider.
 */
export async function startSAMLLogin(url: URL, idToken?: string | null): Promise<void> {
    const nonce = crypto.randomUUID();
    sessionStorage.setItem(SAML_NONCE_STORAGE_KEY, nonce);
    url.searchParams.set('nonce', nonce);
    if (idToken) {
        // Keep the bearer credential out of URLs and request logs.
        url.pathname += '/start';
        const response = await fetch(url, {
            method: 'POST',
            body: new URLSearchParams({ idToken }),
        });
        if (!response.ok) {
            throw new Error('Unable to start SAML login');
        }
        const { loginURL } = await response.json();
        window.location.href = loginURL;
        return;
    }
    window.location.href = url.toString();
}

/**
 * Consume the browser binding before Firebase verifies and accepts the custom token.
 */
export function consumeSAMLNonce(token: string): boolean {
    const expectedNonce = sessionStorage.getItem(SAML_NONCE_STORAGE_KEY);
    if (!expectedNonce) {
        return false;
    }

    try {
        // This is only a precondition: Firebase still verifies the token's signature.
        const { claims } = jose.decodeJwt(token);
        if (
            !claims ||
            typeof claims !== 'object' ||
            !('samlNonce' in claims) ||
            claims.samlNonce !== expectedNonce
        ) {
            return false;
        }
        sessionStorage.removeItem(SAML_NONCE_STORAGE_KEY);
        return true;
    } catch {
        return false;
    }
}
